import { useFormik } from "formik";
import { articleFormSchema } from "libs/validation/schemas";
import mediaUploader from "api/mediaUploader.api";
import useAuth from "hooks/useAuth";
import { CACHE_SIZE_UNLIMITED } from "firebase/firestore";
import { runFireworks } from "components/confetti";

const FIELDS = {
  TITLE: "title",
  DESCRIPTION: "description",
  CONTENT: "content",
  CACHE_SIZE_UNLIMITED,
  CATEGORIES: "categories",
  PUBLISHED: "published",
  CHOICES: "choices",
  LEVEL: "level",
  DEADLINE: "deadline",
  END_OF_VOTING: "endOfVoting",
  IMAGE: "image",
};

const useSurveyForm = (props) => {
  const { survey, create, update, id } = props;
  const { currentUser } = useAuth();
  const surveyForm = useFormik({
    initialValues: {
      [FIELDS.TITLE]: survey.title || "",
      [FIELDS.DESCRIPTION]: survey.description || "",
      [FIELDS.CONTENT]: survey.content || "",
      [FIELDS.CATEGORIES]: survey.categories || [],
      [FIELDS.PUBLISHED]: survey.published || false,
      [FIELDS.CHOICES]: survey.choices || [],
      [FIELDS.LEVEL]: survey.level || 1,
      [FIELDS.DEADLINE]: survey.deadline || "",
      [FIELDS.END_OF_VOTING]: survey.endOfVoting || "",
      [FIELDS.IMAGE]: survey.image || "",
    },
    enableReinitialize: true,
    validationSchema: articleFormSchema,
    onSubmit: async (values) => {
      let contentUrl = "";
      let imageUrl = "";
      if (typeof values[FIELDS.IMAGE] !== "string") {
        imageUrl = await mediaUploader(
          values[FIELDS.IMAGE],
          `predictors/${id}/poster`,
        );
      } else {
        imageUrl = values[FIELDS.IMAGE];
      }

      if (values[FIELDS.CONTENT]) {
        const blob = new Blob([values[FIELDS.CONTENT]], { type: "text/plain" });
        const file = new File([blob], "content.txt", { type: "text/plain" });
        contentUrl = await mediaUploader(file, `surveys/${id}/content`);
      }

      create({
        ...values,
        createdAt: Date.now(),
        content: contentUrl,
        image: imageUrl,
        author: { id: currentUser?.id, displayName: currentUser.displayName },
        type: "pending",
      });
      update(id, {
        ...values,
        content: contentUrl,
        image: imageUrl,
        updatedAt: Date.now(),
      });
      runFireworks();
    },
  });

  const { values, setFieldValue, handleSubmit, resetForm } = surveyForm;

  return {
    surveyForm,
    FIELDS,
    values,
    setFieldValue,
    handleSubmit,
    resetForm,
    errors: surveyForm.errors,
  };
};

export default useSurveyForm;
